// /components/ranking/InfoBlock.tsx

import React, { useState } from 'react';
import { Paper, Typography, Stack, Link, Dialog, DialogTitle, IconButton, DialogContent } from '@mui/material';
import {
    Article as ArticleIcon,
    BarChart as BarChartIcon,
    InfoOutlined as InfoOutlinedIcon,
    Close as CloseIcon
} from '@mui/icons-material'

export const InfoBlock: React.FC = () => {
    const [openVideo, setOpenVideo] = useState(false);
    return (
        <Paper elevation={0} sx={{ p: 2, mb: 3, border: '1px solid', borderColor: 'divider', borderRadius: '12px', bgcolor: 'grey.50' }}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>Información Adicional</Typography>
            <Stack direction={{ xs: 'column', md: 'row' }} spacing={{ xs: 2, md: 4 }} alignItems="flex-start">
                <Link
                    href="https://www.dspace.espol.edu.ec/bitstream/123456789/45310/3/REGLAMENTO%20DE%20RECONOCIMIENTOS%20INSTITUCIONALES-signed.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ display: 'flex', alignItems: 'center', textDecoration: 'none', fontWeight: 'medium' }}
                >
                    <ArticleIcon sx={{ mr: 1, color: 'primary.main' }} />
                    <Typography component="span" color="text.primary" sx={{ '&:hover': { textDecoration: 'underline' } }}>
                        Reglamento de Reconocimientos
                    </Typography>
                </Link>
                <Link
                    href="https://www.espol.edu.ec/es/cuartiles-mayores"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ display: 'flex', alignItems: 'center', textDecoration: 'none', fontWeight: 'medium' }}
                >
                    <BarChartIcon sx={{ mr: 1, color: 'primary.main' }} />
                    <Typography component="span" color="text.primary" sx={{ '&:hover': { textDecoration: 'underline' } }}>
                        Cuartiles Mayores
                    </Typography>
                </Link>
                <Link
                    component="button"
                    onClick={() => setOpenVideo(true)}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        textDecoration: 'none',
                        fontWeight: 'medium',
                        border: 'none',
                        bgcolor: 'transparent',
                        cursor: 'pointer',
                        p: 0
                    }}
                >
                    <InfoOutlinedIcon sx={{ mr: 1, color: 'primary.main' }} />
                    <Typography component="span" color="text.primary" sx={{ '&:hover': { textDecoration: 'underline' } }}>
                        Explicación del Cálculo
                    </Typography>
                </Link>
            </Stack>

            <Dialog
                open={openVideo}
                onClose={() => setOpenVideo(false)}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    Explicación del Cálculo
                    <IconButton onClick={() => setOpenVideo(false)}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ p: 0, bgcolor: 'black' }}>
                    <video
                        width="100%"
                        controls
                        autoPlay
                        preload="metadata"
                        style={{ display: 'block' }}
                    >
                        <source src="/videoExplicacion.mp4" type="video/mp4" />
                        Tu navegador no soporta la reproducción de video.
                    </video>
                </DialogContent>
            </Dialog>

        </Paper>
    );
};